jQuery(document).ready(function(){
  jQuery('.closemenu').click(function(){
    jQuery('.section-header .header header-drawer .header__icon').trigger('click');
  });
  jQuery(".logosrs_carousel").owlCarousel({
        autoplay: !0,
        loop: !0,
        dots: !1,
        slideTransition: "linear",
        autoplayTimeout: 4500,
        autoplayHoverPause: !0,
        autoplaySpeed: 4500,
        responsive: {
            0: {
                items: 3,
        margin: 20
            },
            767: {
                items: 5,
        margin: 20
            }
        }
    });
  jQuery(".logosec_inn").owlCarousel({
        autoplay: !0,
        loop: !0,
        dots: !1,
        slideTransition: "linear",
        autoplayTimeout: 4500,
        autoplayHoverPause: !0,
        autoplaySpeed: 4500,
        responsive: {
            0: {
                items: 2,
        margin: 20
            },
            767: {
                items: 6,
        margin: 40
            }
        }
    });
  jQuery('.bstslr_carousel').owlCarousel({
    loop:true,
    nav:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
          margin:0,
        },
        767:{
            items:3,
    margin:15
        }
    }
});
  jQuery('.bstslrnw_carousel').owlCarousel({
    loop:true,
    nav:true,
    responsiveClass:true,
    center:true,
    responsive:{
        0:{
            items:1.5,
          margin:0
        },
        767:{
            items:3.5,
    margin:15
        },
        1279:{
            items:6,
    margin:15
        }
    }
});
  jQuery('.video_carousel').owlCarousel({
    loop:true,
    margin:12,
    nav:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:2
        },
        768:{
            items:3
        },
        1025:{
            items:5
        }
    }
});
  jQuery(".play_btn_vd").on('click', function() {
  jQuery(".play_btn_vd").removeClass('hide');
  jQuery(this).addClass('hide');
  jQuery('.f_vdsld .f_vdsld_sld .item video').trigger('pause');
  jQuery(this).parent().find('video').get(0).play();
});
  jQuery(".f_vdsld .f_vdsld_sld .item video").on('click', function() {
  jQuery(this).trigger('pause');
  jQuery(".play_btn_vd").removeClass('hide');
});
  jQuery('.srs_carousel').owlCarousel({
    margin:10,
    nav:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
          loop:true
        },
        767:{
            items:3,
          loop:false
        }
    }
});
  jQuery('.icon_carousel').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:3
        }
    }
});
  jQuery('.scent_carousel').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1
        }
    }
});
  jQuery('.f_faq_question').click(function(){
    jQuery(this).next('.f_faq_answer').slideToggle();
  });
  jQuery('.f_prd_accrd_t').click(function(){
    jQuery(this).next('.f_prd_accrd_c').slideToggle();
  });
  jQuery('.bnf_carousel').owlCarousel({
    nav:true,
    loop:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:3,
          margin:16
        },
        767:{
            items:3,
          margin:16
        },
        1025:{
            items:5,
          margin:16
        }
    }
});
  var current = location.pathname;
    jQuery('.f_prdgrdsld .flta a').each(function(){
        var jQuerythis = jQuery(this);
        if(jQuerythis.attr('href').indexOf(current) !== -1){
            jQuerythis.addClass('active');
        }
    });

    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 6; 
    var syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false, 
        dots: true,
        loop: true,
        responsiveRefreshRate: 200,
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
    }).on('changed.owl.carousel', syncPosition);

    sync2
        .on('initialized.owl.carousel', function() {
            sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
            items: slidesPerPage,
            dots: true,
            nav: true,
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: slidesPerPage, 
            responsiveRefreshRate: 100
        }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });

    var width = jQuery(window).width();
 
        var sticky_navigation_offset_top = 1;
        var sticky_navigation = function() {
            var scroll_top = jQuery(window).scrollTop();
            if (scroll_top > sticky_navigation_offset_top) {
                jQuery('.section-header').addClass("shopify-section-header-sticky");
            } else {
                jQuery('.section-header').removeClass("shopify-section-header-sticky");
            }
        };
        sticky_navigation();
        jQuery(window).scroll(function() {
            sticky_navigation();
        });
  
  jQuery(".a_flton").click(function() {
  jQuery(".f_prdgrdsld_filter a").removeClass("active");
  jQuery(this).addClass("active");
  jQuery(".f_prd_ch").parent().addClass("hidectg");
  jQuery(".f_prd_ch[data-collection=" + jQuery(this).attr("id") + "]").parent().removeClass("hidectg");
    return false();
});
  
  jQuery(".f_prdgrdsld_filter .shopall").click(function() {
  jQuery(".f_prdgrdsld_filter a").removeClass("active");
  jQuery(this).addClass("active");
  jQuery(".f_prd_ch").parent().removeClass("hidectg");
    return false();
});

/** 
  if (jQuery.cookie("popup_1_2") == null) {
    setTimeout(function() {
  jQuery('.f_popupfst').addClass('show');
      }, 10000);
      jQuery.cookie("popup_1_2", "2");
   }
else {
 jQuery('.f_popupfst').hide();
}
**/
jQuery(".a_popfst").click(function() {
     jQuery('.f_popupfst').addClass('show');
  });
  jQuery(".f_popupfst_close").click(function() {
     jQuery('.f_popupfst').removeClass('show');
  });

  /* if (jQuery.cookie("popup_1_3") == null) {
    jQuery(window).load(function(){
    setTimeout(function() {
  jQuery('.f_popupfst_spin').addClass('show');
      }, 10000);
      });
      jQuery.cookie("popup_1_3", "2");
   }
else {
 jQuery('.f_popupfst_spin').hide();
}**/

    setTimeout(function() {
  jQuery('.f_popupfst_spin').addClass('show');
      }, 2000);

  jQuery(".f_popupfst_close").click(function() {
     jQuery('.f_popupfst_spin').hide();
  });

  jQuery("input[value='Buy 1 Pack']").click(function() {
     jQuery('.vrtinfotxt_txt').addClass("hided");
     jQuery('.vrtinfotxt_txt').removeClass("show");
    jQuery('.vrtinfotxt_txt.vrtinfotxt_txt1').addClass("show");
    jQuery('.prdtpperc').addClass("hide");
  });

  jQuery("input[value='Buy 2 Get 1 Free']").click(function() {
     jQuery('.vrtinfotxt_txt').addClass("hided");
     jQuery('.vrtinfotxt_txt').removeClass("show");
    jQuery('.vrtinfotxt_txt.vrtinfotxt_txt2').addClass("show");
    jQuery('.prdtpperc').addClass("hide");
    jQuery('.prdtpperc2').removeClass("hide");
    jQuery('.prdtpperc2').addClass("show");
  });

  jQuery("input[value='Buy 4 Get 2 Free']").click(function() {
     jQuery('.vrtinfotxt_txt').addClass("hided");
     jQuery('.vrtinfotxt_txt').removeClass("show");
    jQuery('.vrtinfotxt_txt.vrtinfotxt_txt4').addClass("show");
    jQuery('.prdtpperc').addClass("hide");
    jQuery('.prdtpperc4').removeClass("hide");
    jQuery('.prdtpperc4').addClass("show");
  });
jQuery(window).load(function() {
  jQuery(".smartrr-group-active, .smartrr-group-inactive:not(.smartrr-otp)").click(function() {
     jQuery('.vrtinfotxt').css('display','flex');
     jQuery('.price_value_df p b').show();
     jQuery('.per_value2').removeClass("ihide");
     jQuery('.per_value4').removeClass("ihide");
     jQuery('.pack1, .pack2, .pack4').removeClass("ihide");
     jQuery('.f_prd_iclist ul li.hideotp').css('display','none');
     jQuery('.product__info-wrapper').removeClass("product_otp");
  });
  jQuery(".smartrr-otp").click(function() {
     jQuery('.vrtinfotxt').css('display','none');
     jQuery('.price_value_df p b').hide();
     jQuery('.per_value2').addClass("ihide");
     jQuery('.per_value4').addClass("ihide");
     jQuery('.pack1, .pack2, .pack4').addClass("ihide");
     jQuery('.f_prd_iclist ul li.hideotp').css('display','flex');
     jQuery('.product__info-wrapper').addClass("product_otp");
  });
  });
jQuery(document).ready(function() {
  jQuery(".smartrr-group-active, .smartrr-group-inactive:not(.smartrr-otp)").click(function() {
     jQuery('.vrtinfotxt').css('display','flex');
     jQuery('.price_value_df p b').show();
     jQuery('.per_value2').removeClass("ihide");
     jQuery('.per_value4').removeClass("ihide");
     jQuery('.pack1, .pack2, .pack4').removeClass("ihide");
     jQuery('.f_prd_iclist ul li.hideotp').css('display','none');
     jQuery('.product__info-wrapper').removeClass("product_otp");
  });
  jQuery(".smartrr-otp").click(function() {
     jQuery('.vrtinfotxt').css('display','none');
     jQuery('.price_value_df p b').hide();
     jQuery('.per_value2').addClass("ihide");
     jQuery('.per_value4').addClass("ihide");
     jQuery('.pack1, .pack2, .pack4').addClass("ihide");
     jQuery('.f_prd_iclist ul li.hideotp').css('display','flex');
     jQuery('.product__info-wrapper').addClass("product_otp");
  });
  });

  jQuery.fn.visible = function(partial) {  
      var $t            = jQuery(this),
          $w            = jQuery(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;   
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };

jQuery(window).scroll(function(event) {
  jQuery(".f_prdpg").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      
       el.removeClass("f_prdpg_sticky");
    } else {
      el.addClass("f_prdpg_sticky"); 
    }
  });
});



var myDiv = jQuery('.product-form__buttons .product-form__submit');
  var loopCount = 0;
  var maxLoops = 1000000000;

  function toggleClasses() {
    if (loopCount < maxLoops) {
      myDiv.attr("style", "");
      setTimeout(function() {
        myDiv.removeAttr("style", "");
        loopCount++;
        setTimeout(toggleClasses, 0);
      }, 0); 
    }
  }
  toggleClasses();

   jQuery(".f_ingfaq .f_ingfaq_dv .f_ingfaq_dvcnt h3").click(function() {
     jQuery(this).next('.f_p').slideToggle();
  });

   jQuery(".hscnt").click(function() {
         $(this).text($(this).text() == 'Show Less' ? 'Show More' : 'Show Less');
     jQuery('.f_prdgrdsld_longdesc').toggleClass('showall');
  });

  var pathname = window.location.href; 
    jQuery('.a_prdmetavar').each(function () {
        if (this.href == pathname) {
            jQuery(this).addClass('activevariant');
        }
    });

});